import { Box, Card, Typography, styled } from "@mui/material"
import { EvolutionStatChip } from "../../../Chip"

type Layout = "basic" | "evolution"

export interface AsideSectionSummarySecondaryCardProps {
  title: string
  kpi: string | number
  evolution?: number | null
  layout?: Layout
}
export const AsideSectionSummarySecondaryCard = (
  props: AsideSectionSummarySecondaryCardProps,
) => {
  const { title, kpi, evolution, layout = "basic" } = props
  const displayEvolution = Object.prototype.hasOwnProperty.call(props, "evolution")

  return (
    <AsideSectionSummarySecondaryCardRoot layout={layout}>
      <AsideSectionSummarySecondaryTitle>{title}</AsideSectionSummarySecondaryTitle>
      <AsideSectionSummarySecondaryKpi>{kpi}</AsideSectionSummarySecondaryKpi>
      {displayEvolution && (
        <Typography variant="12px">
          <EvolutionStatChip evol={evolution} arrow bold border={false} />
        </Typography>
      )}
    </AsideSectionSummarySecondaryCardRoot>
  )
}

export const AsideSectionSummarySecondaryCardRoot = styled(Card, {
  shouldForwardProp: (props) => props !== "layout",
})<{ layout?: Layout }>(({ theme: { spacing, palette }, layout = "basic" }) => ({
  display: "grid",
  gridTemplateColumns: layout === "basic" ? "1fr auto" : "4fr auto 1fr",
  alignItems: "center",
  gap: spacing(2),
  paddingInline: spacing(2),
  paddingBlock: spacing(1),
  border: "none",
  backgroundColor: palette.common.periwinkleBlue,
}))

AsideSectionSummarySecondaryCardRoot.defaultProps = {
  // @ts-expect-error: shitty types from MUI 💩
  component: Box,
}

export const AsideSectionSummarySecondaryTitle = styled(Typography)(
  ({ theme: { palette } }) => ({
    fontWeight: 500,
    color: palette.primary.dark4,
  }),
)
AsideSectionSummarySecondaryTitle.defaultProps = { variant: "12px" }

export const AsideSectionSummarySecondaryKpi = styled(Typography)(
  ({ theme: { palette } }) => ({
    fontWeight: 600,
    color: palette.common.darkBlue,
    textAlign: "right",
  }),
)
AsideSectionSummarySecondaryKpi.defaultProps = { variant: "20px" }
